// extracted by mini-css-extract-plugin
var _1 = "GretaAIChatFeedbackReasonField-modulefield__tFlFk";
var _2 = "GretaAIChatFeedbackReasonField-modulelabel__YHUFW";
var _3 = "GretaAIChatFeedbackReasonField-modulereasons__DrhJ4";
export { _1 as "field", _2 as "label", _3 as "reasons" }
